import { create } from 'zustand';
import { devtools, persist, PersistOptions } from 'zustand/middleware';
import { StateCreator } from 'zustand/vanilla';

/**
 * If name is provided the store will be persistent.
 *
 * When persisting, an optional `persistOptions` may be supplied (e.g. `partialize`)
 * to control which parts of the state are written to storage. Transient fields such
 * as `loading` flags should be excluded so they are not incorrectly rehydrated after
 * a reload.
 */
export const createStore = <T extends object>(
  name: string | null,
  initializer: StateCreator<T>,
  persistOptions?: Omit<PersistOptions<T, Partial<T>>, 'name'>
) => {
  if (name) {
    return create<T>()(devtools(persist(initializer, { name, ...persistOptions })));
  }

  return create<T>()(devtools(initializer));
};
